export default "__VITE_ASSET__DrvKSG2C__"